import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';

import {
  Badge,
  BadgeContainer,
  ItemThumbnailContainer,
  ThumbnailBehind,
  ThumbnailBox,
} from './styled';

type ItemHighlighted = {
  name: string;
  image: IImageFragment;
};

interface IItemThumbnailWithBadge {
  totalItems: number;
  item: ItemHighlighted;
}

export const ItemThumbnailWithBadge = ({ totalItems, item }: IItemThumbnailWithBadge) => (
  <ItemThumbnailContainer focusable accessibilityLabel={totalItems.toString()}>
    {Array.from({ length: 2 }).map((_, index) => (
      <ThumbnailBehind
        key={index}
        style={{
          transform: [{ rotate: index % 2 === 0 ? '12deg' : '-12deg' }],
        }}
      />
    ))}
    <ThumbnailBox>
      <BadgeContainer>
        <Badge variant="number-solid">{totalItems.toString()}</Badge>
      </BadgeContainer>
      {item && (
        <Picture
          image={item.image}
          accessibilityHidden
          width="$13.5"
          height="$13.5"
          alt={item.name}
        />
      )}
    </ThumbnailBox>
  </ItemThumbnailContainer>
);
